module.exports = __webpack_public_path__ + "static/img/ic_bottom_community_on@2x.c4eded6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_bottom_community_on@2x.png
// module id = r+Vm
// module chunks = 1